import React, { useState, useEffect } from 'react';
import './ThinkingOrb.css';

const TASKS = [
  'Analyzing context...',
  'Searching vector space...',
  'Optimizing response...',
  'Mapping trend signals...',
  'Scanning market data...',
  'Evaluating opportunities...',
  'Correlating patterns...',
  'Processing insights...',
];

const DOT_COUNT = 60;
const RING_COUNT = 5;

function generateDots() {
  const dots = [];
  for (let ring = 0; ring < RING_COUNT; ring++) {
    const dotsInRing = Math.floor(DOT_COUNT / RING_COUNT);
    const phi = (Math.PI / (RING_COUNT + 1)) * (ring + 1);
    for (let i = 0; i < dotsInRing; i++) {
      const theta = (2 * Math.PI / dotsInRing) * i;
      dots.push({ ring, index: i, phi, theta, total: dotsInRing });
    }
  }
  return dots;
}

const dots = generateDots();

const ThinkingOrb = () => {
  const [taskIndex, setTaskIndex] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setTaskIndex((prev) => (prev + 1) % TASKS.length);
        setFading(false);
      }, 400);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="thinking-orb-container">
      <div className="thinking-orb-wrapper">
        <div className="orb-glow"></div>
        <div className="orb-scene">
          <div className="orb-rotate">
            {dots.map((dot, i) => {
              const radius = 90;
              const x = radius * Math.sin(dot.phi) * Math.cos(dot.theta);
              const y = radius * Math.cos(dot.phi);
              const z = radius * Math.sin(dot.phi) * Math.sin(dot.theta);
              const delay = (dot.ring * 0.6) + (dot.index * 0.1);
              const size = 2 + Math.random() * 2;
              return (
                <div
                  key={i}
                  className="orb-dot"
                  style={{
                    transform: `translate3d(${x}px, ${y}px, ${z}px)`,
                    width: `${size}px`,
                    height: `${size}px`,
                    animationDelay: `${delay}s`,
                  }}
                />
              );
            })}
          </div>
        </div>
        <div className="orb-pulse-ring orb-pulse-ring-1"></div>
        <div className="orb-pulse-ring orb-pulse-ring-2"></div>
        <div className="orb-pulse-ring orb-pulse-ring-3"></div>
      </div>
      <p className={`thinking-task-text ${fading ? 'task-fade' : ''}`}>
        {TASKS[taskIndex]}
      </p>
      <p className="thinking-hint">Press Scan to discover trending opportunities</p>
    </div>
  );
};

export default ThinkingOrb;
